import { useLanguage } from "./LanguageContext";
import './languageSwitch.css';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div onClick={toggleLanguage} className={`language-switch ${language}`}>
    </div>
  );
};

export default LanguageSwitcher;
